<template>
  <div class="game-table-flush">
  <vue-good-table 
    styleClass="vgt-table condensed vgt-flush"
    v-bind="tableOptions"
    :columns="columns"
    :rows="rows"
    :sort-options="{enabled: false}"
    :pagination-options="paginationFor(rows)"
    compactMode> 
    <template #table-row="props">
      <div v-if="props.column.field == 'GameName'" class="d-flex align-items-center gap-2">
        <img
          v-if="props.row.GameRewardImg"
          :src="rewardSrc(props.row.GameRewardImg)"
          class="reward-thumb reward-img"
          :alt="props.row.GameName"
          role="button"
          @click.stop="openRewardPhoto(props.row)"
        >
        <span>{{ props.row.GameName }}</span>
      </div>
      <div v-else-if="props.column.field == 'Actions'">
        <div class="d-flex flex-row gap-2 justify-content-end">
          <button 
            class="btn btn-outline-primary btn-sm px-3 py-1 mb-0" 
            type="button"
            @click="store.dispatch('loadOpenGameDetail', props.row.GameID )">
            Detail
          </button>
          <button
            class="btn btn-primary btn-sm px-3 py-1 mb-0"
            type="button"
            @click="store.dispatch('addToGameHandler', {
              GameID: props.row.GameID, 
              GameName: props.row.GameName, 
              GameCredit: props.row.GameCredit
            })"
          >
            Hrát
          </button>          
        </div>
      </div>
      <span v-else>
        {{props.formattedRow[props.column.field]}}
      </span>
    </template>    
    <template #emptystate>
      <div class="text-center">
        <span>Žádné doporučené hry</span>
      </div>
    </template>
  </vue-good-table>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { tableOptions, paginationFor } from '../../../../helpers/tableOptions';
import { formatTrimZeroCents, formatDashIfWhole } from '@/utils/NumberFormat';

const props = defineProps({
  rows: Array
})

const store = useStore();
const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);
const apiRoot = computed(() => process.env.VUE_APP_API_URL);
const rewardSrc = (value) => {
  if (!value) return '';
  if (String(value).startsWith('img/')) return apiRoot.value + value;
  return imgRoot.value + value;
};

const openRewardPhoto = (row) => {
  const src = rewardSrc(row?.GameRewardImg);
  if (!src) return;
  store.dispatch('openLightbox', { src, alt: row.GameName || 'Výhra' });
};

const columns = reactive([
  { 
    label: 'Hra',
    field: 'GameName',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold align-middle td-middle',
    width: '32%'
  },
  {
    label: 'Registrace končí',
    field: 'GameRegister',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end align-middle td-middle',
  },
  { 
    label: 'Od',
    field: 'GameFrom',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end align-middle td-middle',
  },
  { 
    label: 'Kredit',
    field: 'GameCredit',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end align-middle td-middle',
    formatFn: formatDashIfWhole
  },
  { 
    label: 'Kapitál',
    field: 'GameCapital',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end align-middle td-middle',
    formatFn: formatTrimZeroCents
  },
  { 
    label: '',
    field: 'Actions',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'align-middle td-middle',
  }
]);

</script>

<style scoped>
:deep(td.td-middle) {
  vertical-align: middle !important;
}

.reward-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 0.45rem;
  flex-shrink: 0;
  cursor: zoom-in;
}
</style>
